module.exports = __webpack_public_path__ + "img/validated.a1d2a358.png";